<!-- ── Page header ─────────────────────────────────────────────────────────── -->
<div class="dash-page-strip">
  <div class="container">
    <div class="dash-eyebrow">
      <span class="dash-eyebrow-rule"></span>
      <span>Admin</span>
      <span class="dash-eyebrow-rule"></span>
    </div>
    <h1 class="dash-page-title">Orders <em>Dashboard</em></h1>
    <p class="dash-page-sub">Monthly performance overview</p>
  </div>
</div>

<!-- ── Unauthorized ────────────────────────────────────────────────────────── -->
<div class="container" *ngIf="unauthorized">
  <div class="dash-unauth">
    <span class="dash-unauth-icon">✦</span>
    <h3>Access Restricted</h3>
    <p>Admin privileges are required to view this page.</p>
  </div>
</div>

<!-- ── Loading ────────────────────────────────────────────────────────────── -->
<div class="container" *ngIf="loading && !unauthorized">
  <div class="dash-loading">
    <div class="dash-spinner"></div>
    <p>Loading statistics…</p>
  </div>
</div>

<!-- ── Content ────────────────────────────────────────────────────────────── -->
<div class="container dash-content" *ngIf="!loading && !unauthorized">

  <!-- KPI cards -->
  <div class="kpi-grid">
    <div class="kpi-card kpi-card--1">
      <span class="kpi-ornament">✦</span>
      <p class="kpi-label">Total Orders</p>
      <h2 class="kpi-value">{{ totalOrders }}</h2>
      <p class="kpi-sub">Last 12 months</p>
    </div>
    <div class="kpi-card kpi-card--2">
      <span class="kpi-ornament">✦</span>
      <p class="kpi-label">Total Revenue</p>
      <h2 class="kpi-value">{{ totalRevenue | number:'1.0-0' }} <span>LE</span></h2>
      <p class="kpi-sub">Last 12 months</p>
    </div>
    <div class="kpi-card kpi-card--3">
      <span class="kpi-ornament">✦</span>
      <p class="kpi-label">Avg / Month</p>
      <h2 class="kpi-value">{{ avgPerMonth }}</h2>
      <p class="kpi-sub">Orders per month</p>
    </div>
    <div class="kpi-card kpi-card--4" *ngIf="peakMonth">
      <span class="kpi-ornament">✦</span>
      <p class="kpi-label">Peak Month</p>
      <h2 class="kpi-value">{{ peakMonth.label }}</h2>
      <p class="kpi-sub">{{ peakMonth.count }} orders</p>
    </div>
  </div>

  <!-- Bar chart -->
  <div class="chart-section" *ngIf="stats.length > 0">

    <div class="chart-header">
      <div class="chart-title-group">
        <span class="chart-rule"></span>
        <h3 class="chart-title">Orders per Month</h3>
        <span class="chart-rule"></span>
      </div>
      <p class="chart-sub">Non-cancelled orders · last 12 months</p>
    </div>

    <div class="chart-wrap">
      <!-- Y-axis labels -->
      <div class="chart-yaxis">
        <span>{{ maxCount }}</span>
        <span>{{ (maxCount * 0.75) | number:'1.0-0' }}</span>
        <span>{{ (maxCount * 0.50) | number:'1.0-0' }}</span>
        <span>{{ (maxCount * 0.25) | number:'1.0-0' }}</span>
        <span>0</span>
      </div>

      <!-- Bars area -->
      <div class="chart-bars-area">
        <!-- Grid lines -->
        <div class="chart-gridlines">
          <div class="gridline" *ngFor="let _ of [0,1,2,3,4]"></div>
        </div>

        <!-- Bars -->
        <div class="chart-bars">
          <div class="bar-col" *ngFor="let m of stats; let i = index">
            <div class="bar-track">
              <div
                class="bar"
                #barEl
                [style.--bar-h]="barPct(m.count) + '%'"
                [class.bar--peak]="peakMonth && m.month === peakMonth.month && m.year === peakMonth.year"
              >
                <div class="bar-tooltip">
                  <strong>{{ m.count }}</strong>
                  <span>orders</span>
                  <em>{{ m.revenue | number:'1.0-0' }} LE</em>
                </div>
              </div>
            </div>
            <span class="bar-label">{{ m.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty state -->
  <div class="dash-empty" *ngIf="stats.length === 0">
    <span class="dash-empty-ornament">✦</span>
    <p>No orders recorded in the last 12 months.</p>
  </div>

</div>
